import { lazy } from "react";

export const Login = lazy(() => import("./login"));
export const AthleticsDashboard = lazy(() => import("./athletics-dashbaord"));
export const Statistics = lazy(() => import("./statistics"));
export const Settings = lazy(() => import("./settings"));
export const SetPassword = lazy(() => import("./set-password"));
export const ForgotPassword = lazy(() => import("./forgot-password"));
export const OTPVarification = lazy(() => import("./otp-varification"));

// export * from "./login";
// export * from "./m2c-dashbaord";
// export * from "./athletics-dashbaord";
// export * from "./history";
// export * from "./launch-dashboard";
// export * from "./statistics";
// export * from "./settings";
// export * from "./set-password";
// export * from "./m2c-simulation";
// export * from "./forgot-password";
// export * from "./login";
// export * from "./otp-varification";
// export * from "./results";
// export * from "./m2c-golf-sandbox-dashboard";
